import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import Error404View from "../views/Error404View.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
import ContactView from "../views/ContactView.vue";
import ContactResponseView from "../views/ContactResponseView.vue";
import AboutView from "../views/AboutView.vue";
import GalleriesListView from "../views/GalleriesListView.vue";
import GalleriesItemView from "../views/GalleriesItemView.vue";
import ArticlesListView from "../views/ArticlesListView.vue";
import ArticlesItemView from "../views/ArticlesItemView.vue";
import VideosListView from "../views/VideosListView.vue";
import VideosItemView from "../views/VideosItemView.vue";
// import UnderConstructionView from "../views/UnderConstructionView.vue";

Vue.use(VueRouter);

const routes = [
  {
    name: "Início",
    path: "/",
    component: HomeView,
  },
  {
    name: "Contato",
    path: "/contato",
    component: ContactView,
  },
  {
    name: "Quem Somos",
    path: "/quem-somos",
    component: AboutView,
  },
  {
    name: "Eventos",
    path: "/eventos",
    component: GalleriesListView,
  },
  {
    name: "Evento",
    path: "/eventos/:item",
    component: GalleriesItemView,
  },
  {
    name: "Notícias",
    path: "/noticias",
    component: ArticlesListView,
  },
  {
    name: "Notícias",
    path: "/noticias/:item",
    component: ArticlesItemView,
  },
  {
    name: "Vídeos",
    path: "/videos",
    component: VideosListView,
  },
  {
    name: "Vídeos",
    path: "/videos/:item",
    component: VideosItemView,
  },
  {
    name: "Obrigado!",
    path: "/contato/obrigado",
    component: ContactResponseView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    name: "Erro 404",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
